import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import { useCurrentTab } from '../../../organisms/AdvisorView/components/AdvisorViewTabs'
import { ADMIN_ROUTES, ICON_NAMES } from '../../../../constants'
import { useCheckPolicy } from '../../../../hooks'
import { ROLES } from '../../../../policies/admin'
import SydLinkButton from '../../../commonDesign/LinkButton'
import SydButton from '../../../commonDesign/Button'
import { usePermissionGroupsActive } from '../../../../hooks/featureChecks'

const useStyles = makeStyles((theme) => ({
  roundedButton: {
    border: 'var(--border-primary-normal)',
    borderRadius: 'var(--border-radius-round)',
    padding: '0.45rem 1rem',
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    alignSelf: 'flex-start',
    marginLeft: 'auto',
    '& .MuiButton-label': {
      fontSize: '0.75rem'
    }
  },
  disabled: {
    borderColor: 'var(--border-color-neutral-disabled)'
  },
  actions: {
    marginLeft: 'auto',
    display: 'flex',
    gap: '0.5rem'
  }
}))

function HeaderActions ({ setModalOpen }) {
  const classes = useStyles()
  const tabValue = useCurrentTab()
  const canEditRoles = useCheckPolicy(ROLES.editWealthOwnerRoles)
  const canEditUsers = useCheckPolicy('admin_edit_wo_users')
  const hasWOPermissionGroupPermissions = useCheckPolicy('admin_edit_wo_permissions')
  const hasWOPermissionGroupFeatureFlag = usePermissionGroupsActive()
  const canEditPermissionGroups = hasWOPermissionGroupPermissions && hasWOPermissionGroupFeatureFlag

  if (tabValue === 'households') {
    return (
      <div className={classes.actions}>
        <SydLinkButton
          to={ADMIN_ROUTES.NEW_CLIENT}
          size='sm'
          variant='primary'
          icon={ICON_NAMES.add}
        >
          Add Household
        </SydLinkButton>
      </div>
    )
  }

  if (tabValue === 'users' && canEditUsers) {
    return (
      <div className={classes.actions}>
        <SydLinkButton
          variant='outline'
          size='sm'
          to={`${ADMIN_ROUTES.WEALTH_OWNERS}/deactivated`}
          icon={ICON_NAMES.user}
        >
          View Deactivated
        </SydLinkButton>
      </div>
    )
  }

  if (tabValue === 'experiences' && canEditRoles) {
    return (
      <div className={classes.actions}>
        <SydLinkButton
          variant='primary'
          size='sm'
          to={`${ADMIN_ROUTES.WEALTH_OWNERS}/roles/new`}
          icon={ICON_NAMES.add}
        >
          Add Experience
        </SydLinkButton>
      </div>
    )
  }

  if (tabValue === 'permissionGroups' && canEditPermissionGroups) {
    return (
      <div className={classes.actions}>
        <SydButton
          variant='primary'
          size='sm'
          onClick={() => setModalOpen(true)}
          icon={ICON_NAMES.add}
        >
          Add Permission Group
        </SydButton>
      </div>
    )
  }

  return null
}

HeaderActions.propTypes = {
  setModalOpen: PropTypes.func
}

export default HeaderActions
